import { render } from "./SitemapDataView.vue?vue&type=template&id=f2bf15bc"
import script from "./SitemapDataView.vue?vue&type=script&lang=js"
export * from "./SitemapDataView.vue?vue&type=script&lang=js"

import "./SitemapDataView.vue?vue&type=style&index=0&id=f2bf15bc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__